export const STREAM_CURSOR_HTML = '<span data-stream-cursor="true" aria-hidden="true"></span>';

const LAST_TEXT_BLOCK = /<\/(p|li|h[1-6]|blockquote)>(?![\s\S]*<\/(?:p|li|h[1-6]|blockquote)>)/i;

export function insertStreamCursor(html: string): string {
	const match = html.match(LAST_TEXT_BLOCK);
	if (!match || match.index == null) {
		return html + STREAM_CURSOR_HTML;
	}

	return html.slice(0, match.index) + STREAM_CURSOR_HTML + html.slice(match.index);
}
